import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { colours } from "@/utils";
import { Device } from "@/utils/device";
import { CL } from "@/components/Typography";
import RxContentBlockTitle from "@/components/ui/display/RxContentBlockTitle";
import MarketingLink from "../marketing/MarketingLink";

const CareersSuperchargeContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.CopyContainer>
        <RxContentBlockTitle>
          <S.RoxboroughFontWrap>
            <S.Italic>Supercharging </S.Italic>community <br />
          </S.RoxboroughFontWrap>
          no matter <br />
          where you start
        </RxContentBlockTitle>
        <CL>
          We are an inclusive and compassionate global community, connected
          through digital and physical spaces. We lead the conversations that
          inspire positive change and recognition for all. AllBright
          supercharges careers; inviting women to invest in their development
          with access to world-class learning and thought leadership. The
          AllBright collective is fuelled by ambition and a commitment to
          achieving success.
        </CL>
        <CL weight="700">Together, the possibilities are endless.</CL>
        <CL>
          AllBright Collective is an equal opportunity employer. We celebrate
          diversity and are committed to creating an inclusive environment for
          all employees. If you want to join us on our journey, we want to hear
          from you.
        </CL>
        <MarketingLink
          animationColour={colours.marketingOrange}
          colour={colours.teal}
          data-cy="DEI-link"
          href="/DEI"
          linkText="Commitment to equality"
        />
      </S.CopyContainer>
      <S.ImageContainer>
        <Image
          src="/images/careers/careers-snapshot.jpg"
          alt=""
          layout="fill"
          objectFit="cover"
        />
      </S.ImageContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  background: ${colours.shellOverlay};
  background-size: cover;
  padding: 10%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;

  @media (min-width: ${Device.tablet}) {
    padding: 5% 10%;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 5% 10%;
    flex-direction: row;
    gap: 6rem;
  }
`;

S.CopyContainer = styled.div`
  flex: none;
  position: relative;
  width: 100%;
  padding: 0 0 5% 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (min-width: ${Device.tablet}) {
    gap: 3rem;
  }

  @media (min-width: ${Device.desktop}) {
    width: 50%;
    padding: 0 0 2rem 0;
    justify-content: space-between;
  }
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.Italic = styled.span`
  font-style: italic;
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.ImageContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  aspect-ratio: 2/1;
  border-radius: 5px;

  @supports not (aspect-ratio: 2/1) {
    &::before {
      float: left;
      padding-top: 50%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (min-width: ${Device.desktop}) {
    aspect-ratio: 1/1.2;

    @supports not (aspect-ratio: 1/1.2) {
      &::before {
        float: left;
        padding-top: 120%;
        content: "";
      }
      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }
`;

export default CareersSuperchargeContent;
